// supabase.ts
import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const mode = import.meta.env.MODE;

// Optional debug log (masked) — only runs outside production
if (mode !== 'production') {
  // Mask most of the URL to avoid leaking secrets in logs
  const urlPreview = supabaseUrl ? `${supabaseUrl.slice(0, 20)}...` : 'missing';
  // Do not print the anon key (even masked) to avoid bad habits
  // eslint-disable-next-line no-console
  console.log('Supabase config check:', {
    hasUrl: Boolean(supabaseUrl),
    hasKey: Boolean(supabaseAnonKey),
    urlPreview,
    mode,
  });
}

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('Missing Supabase environment variables!', {
    hasUrl: Boolean(supabaseUrl),
    hasKey: Boolean(supabaseAnonKey),
  });
  throw new Error('Missing Supabase environment variables');
}

// Typed client using your generated Database types  
// Configure for URL hash-based cross-subdomain authentication
// detectSessionInUrl automatically detects and restores sessions from URL hash fragments
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    autoRefreshToken: true,
  },
});

if (mode !== 'production') {
  // eslint-disable-next-line no-console
  console.log('Supabase client created successfully');
}

// Kept from your existing file
export type SignupData = {
  email: string;
  user_type: string;
  state: string;
};
